import React from 'react';
import LinkedStateMixin from 'react-addons-linked-state-mixin';
import { firebaseRoot } from './../../utils/firebase-utils';
import ReactFireMixin from 'reactfire';

import MobileHeader from '../../components/MobileHeader/MobileHeader';
import TouchButton from '../../components/TouchButton';
import TouchLink from '../../components/TouchLink';
import Input from 'react-bootstrap/lib/Input';
import Glyphicon from 'react-bootstrap/lib/Glyphicon';

import FormSection from '../../components/FormSection/FormSection';
import FormGroup from '../../components/FormGroup/FormGroup';

function bookImageByIsbn(isbn) {
    let id = isbn.toString();
    let subdir = id.substring(id.length - 3);
    return `http://www.smakprov.se/l/${subdir}/${isbn}.png`;
}

const SignupSchool = React.createClass({
	mixins: [LinkedStateMixin, ReactFireMixin],

	contextTypes: {
		history: React.PropTypes.object.isRequired,
		userRef: React.PropTypes.object
	},

    getInitialState() {
        return {
            school: this.context.userRef.val().school,
            class: this.context.userRef.val().class,
            grade: this.context.userRef.val().grade
        }
    },

    componentWillMount() {
        this.schoolsListRef = firebaseRoot.child('content/schools');
        this.bindAsArray(this.schoolsListRef, 'schoolsList');
    },

	nextStep(e) {
		e.preventDefault();
		this.context.history.pushState(null, '/signup/done', null);
	},

	render() {
		return (
			<div className="screen-wrap">
				<MobileHeader
					lessonId={this.props.params.lessonId}
					problemId={this.props.params.problemId}
					bookId={this.props.params.bookId}
					type='signupSteps'
					title='School'
					step="school"
					// Don't show the back button on the root screen.
					backButton={this.props.location.pathname.length > 1}
				/>
				<div className="screen-content">
					<form className="section-wrap" onSubmit={this.nextStep}>
						<div className="section-body">
							<div className="profile-school-book-wrap">
								<div className="profile-school-book">
									{
										(this.context.userRef.val().isbn) && <img src={bookImageByIsbn(this.context.userRef.val().isbn)} alt={this.context.userRef.val().isbn}/>
									}
								</div>
								<TouchButton className="profile-school-btn" bsStyle="link"><Glyphicon glyph="barcode"/></TouchButton>
							</div>
							<div className="">
								<FormSection>
                                    <div className="ma-form-group ma-form-link-wrap">
                                        <TouchLink to="/signup/book" className="ma-form-link"><span className="link-text">Book</span> <Glyphicon glyph="menu-right"/></TouchLink>
                                    </div>
                                    <FormGroup label="School">
                                        <Input type="select" valueLink={this.userLinkState('school')}>
                                            <option>Select your school</option>
                                            {this.state.schoolsList.map(theschool => {
                                                return (
                                                    <option key={theschool['.key']} value={theschool.name}>{theschool.name}</option>
                                                );
                                            })}
                                        </Input>
                                    </FormGroup>
                                    <FormGroup label="Class">
                                        <Input type="text" placeholder="Type your class" valueLink={this.userLinkState('class')}/>
                                    </FormGroup>
                                    <FormGroup label="My grade">
                                        <Input type="select" valueLink={this.userLinkState('grade')}>
                                            <option>Select your grade</option>
                                            <option value="grade1">Grade type 1</option>
                                            <option value="grade2">Grade type 2</option>
                                            <option value="grade3">Grade type 3</option>
                                            <option value="grade4">Grade type 4</option>
                                            <option value="grade5">Grade type 5</option>
                                            <option value="grade6">Grade type 6</option>
                                            <option value="grade7">Grade type 7</option>
                                            <option value="grade8">Grade type 8</option>
                                            <option value="grade9">Grade type 9</option>
                                        </Input>
                                    </FormGroup>
								</FormSection>
							</div>
						</div>
						<div className="section-footer">
							<TouchButton type="submit" bsStyle="primary" bsSize="large" block>Next</TouchButton>
						</div>
					</form>
				</div>
			</div>
		);
	},

    userLinkState(name) {
        return {
            value: this.state[name],
            requestChange: (newValue) => {
                this.setState({[name]: newValue});
                this.context.userRef.ref().child(name).set(newValue).then(
                    null, window.alert
                );
            }
        }
    }
});

export default SignupSchool;


/** WEBPACK FOOTER **
 ** ./src/screens/signup/SignupSchool.js
 **/